module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe-wechat5_cn@3x.e52223a3.png";